import Onboarding from './OnboardingRequests'

export default {
  Onboarding
}